import { StatusBar, Style } from '@capacitor/status-bar';
import { SplashScreen } from '@capacitor/splash-screen';
import { platform } from './identity';

let initialized = false;
let splashHidden = false;

export async function initializeSystemUi({ native = platform.isNative, statusBar = StatusBar } = {}) {
  if (!native || initialized) return false;
  initialized = true;
  await statusBar.setStyle({ style: Style.Light });
  return true;
}

export async function hideLaunchSplash({ native = platform.isNative, splash = SplashScreen } = {}) {
  if (!native || splashHidden) return false;
  splashHidden = true;
  await splash.hide({ fadeOutDuration: 180 });
  return true;
}

export function resetSystemUiForTests() { initialized = false; splashHidden = false; }
